// Phase 3 step #7: thin facade for the project I/O module. Mirrors the
// `createGenerationFacade` shape from src/generation/facade.js so the HTML
// late-bind swap can use the same pattern.

import {
    PROJECT_VERSION,
    DEFAULT_PROJECT_UNITS,
    numOrNull,
    numOrZero,
    emptyProject,
    normalizeImportedMotion,
    normalizeImportedAxis,
    migrateLegacyV1,
    normalizeProjectImport,
    serializeProjectExport
} from "./import-export.js";

export const PROJECT_IO_FACADE_KEYS = Object.freeze([
    "PROJECT_VERSION",
    "DEFAULT_PROJECT_UNITS",
    "numOrNull",
    "numOrZero",
    "emptyProject",
    "normalizeImportedMotion",
    "normalizeImportedAxis",
    "migrateLegacyV1",
    "normalizeProjectImport",
    "serializeProjectExport"
]);

export function createProjectIoFacade() {
    return {
        PROJECT_VERSION,
        DEFAULT_PROJECT_UNITS,
        numOrNull,
        numOrZero,
        emptyProject,
        normalizeImportedMotion,
        normalizeImportedAxis,
        migrateLegacyV1,
        normalizeProjectImport,
        serializeProjectExport
    };
}
